<template>
  <div class="pa-6">
    <v-overlay :value="visible"></v-overlay>
    <v-navigation-drawer
      fixed
      hide-overlay
      right
      temporary
      width="550"
      :value="visible"
      @input="checkInputValue"
    >
      <p class="px-4 py-6 ma-0 pa-0 h6">
        {{ $t('idea_match.similar_revs') }}
      </p>

      <v-divider />

      <v-expansion-panels flat class="py-2">
        <v-expansion-panel
          v-for="rev in revsToShow"
          :key="rev._id"
          activeClass="active-class"
        >
          <v-expansion-panel-header>
            <div>
              <div class="d-flex justify-space-between align-center ">
                <p
                  class="ma-0 pa-0 mb-1 text-truncate text-truncate-target"
                  style="max-width: 340px; line-height: 1.35;"
                >
                  {{ rev.name }}
                </p>
                <RevStatus :rev="rev" class="me-2" showValidationIcons />
              </div>
              <div class="d-flex mt-1 label grey--text">
                {{ humanDate(rev.createdAt) }}
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-chip small outlined pill class="mb-4 ps-0">
              <UserAvatar
                class="me-2"
                size="24px"
                fontSize="10px"
                :account="rev.owner"
              />
              {{ getShortenedName(rev.owner) }}
            </v-chip>

            <p class="ma-0 pa-0 caption grey--text">
              {{ $t('common.location') }}
            </p>

            <div class="d-flex mt-2 mb-5">
              <v-chip small outlined>{{ rev.site.name }}</v-chip>
            </div>

            <v-textarea
              data-private
              dense
              outlined
              no-resize
              auto-grow
              row-height="15"
              readonly
              hide-details
              :label="$t('idea_match.what_is_the_problem')"
              :value="rev.cycle.relateProblem || ''"
            />
            <MediaContainer
              onlyThumbnails
              readOnly
              class="mt-4 mb-6 media-container"
              :images="getRelatePhotos(rev)"
            />
            <v-textarea
              data-private
              dense
              outlined
              no-resize
              auto-grow
              row-height="15"
              readonly
              hide-details
              :label="$t('idea_match.what_did_you_do')"
              :value="rev.cycle.experimentDone || ''"
            />
            <MediaContainer
              onlyThumbnails
              readOnly
              class="mt-4 media-container"
              :images="getExperimentPhotos(rev)"
            />

            <div class="d-flex justify-end">
              <Button
                color="primary"
                class="me-2"
                plain
                size="small"
                :text="$t('idea_match.go_to_rev')"
                @click="goToRev(rev)"
              />

              <Button
                color="primary"
                size="small"
                :text="$t('rev.replication.replicate')"
                @click="handleReplicate(rev)"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { utils } from 'frontend-js-shared'
import _ from 'lodash'
import eventHub, { HUB_EVENTS } from '@/lib/event-hub'

import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'
import revMixin from '@/mixins/revMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'
import RevStatus from '@/components/Rev/RevStatus.vue'
import MediaContainer from '@/components/MediaContainer/MediaContainer.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'IdeaMatchDrawer',

  mixins: [mixin, userMixin, revMixin],

  components: {
    Button,
    MediaContainer,
    RevStatus,
    UserAvatar,
  },

  props: {
    visible: Boolean,
    revs: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      revsToShow: [],
    }
  },

  watch: {
    revs: {
      immediate: true,
      handler(newValue) {
        if (!newValue.length) return (this.revsToShow = [])
        this.revsToShow = this.revs
      },
    },
  },

  methods: {
    humanDate(date) {
      return utils.dates.humanDate(date)
    },

    getRelatePhotos(rev) {
      return rev?.cycle?.relatePhotos ?? []
    },

    getExperimentPhotos(rev) {
      return rev?.cycle?.experimentPhotos ?? []
    },

    goToRev(rev) {
      this.$emit('visitSuggestion')

      const route = this.generateRevRoute(
        rev.organization._id,
        this.$constants.revTypes.improvementIdea,
        rev._id
      )
      this.navigateTo(route)
    },

    checkInputValue(val) {
      if (!val) this.$emit('close')
    },

    handleReplicate(rev) {
      this.$emit('close')
      eventHub.$emit(HUB_EVENTS.REV_VIEW.REPLICATE_REV, _.cloneDeep(rev))
    },
  },
}
</script>
<style lang="scss">
.media-container {
  pointer-events: none;
}
.active-class .text-truncate-target {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  margin-bottom: 4px;
}
</style>
